import { tss } from 'tss-react/mui';
import { SearchResult, SearchResults } from 'types/Search';
import { SearchViewProps } from '../SearchViewProps';
import SearchTableListHeader from './header';
import Row from './row';
import { useComponentSize } from 'hooks/useComponentSize';
import { useRef } from 'react';
import { Box } from '@mui/material';

interface SearchListTableProps {
  data: SearchResults;
  logItemClick: Function;
}

const SearchListTable = ({
  data,
  logItemClick,
  ...props
}: SearchListTableProps & SearchViewProps) => {
  const refTable = useRef<HTMLDivElement | null>(null);
  const { width } = useComponentSize(refTable);
  const columns = getTableColumnsAndSize({ width });
  const { classes } = useSearchListTableStyles({
    columns: columns.columnsWidth
  });

  return (
    <Box ref={refTable} sx={{ flexGrow: 1 }}>
      <SearchTableListHeader
        classes={classes}
        columns={columns.columnsVisible}
        selectionModeEnabled={props.selectionModeEnabled}
      />
      {data.results.map((product: SearchResult) => {
        return (
          <Row
            key={product.document.key}
            product={product}
            logItemClick={logItemClick}
            classes={classes}
            columns={columns.columnsVisible}
            bookmarked={product.document.bookmarked ?? false}
            onBookmarkChange={bookmarked =>
              props.onBookmarkChange?.(product.document, bookmarked)
            }
            selected={props.isSelected(product.document.id)}
            onSelectedChange={selected =>
              props.onSelectedChange(product.document, selected)
            }
            selectionModeEnabled={props.selectionModeEnabled}
            canSelectMore={props.canSelectMore}
          />
        );
      })}
    </Box>
  );
};

export default SearchListTable;

const getTableColumnsAndSize = ({ width }: { width: number }) => {
  const cases = {
    small: 550,
    medium: 780
  };

  switch (true) {
    case width <= cases.small: //for mobile phones
      return {
        columnsWidth: '34px minmax(100px, 1fr) 90px',
        columnsVisible: {
          name: true,
          description: false,
          actions: false
        }
      };
    case width <= cases.medium: //we remove the description
      return {
        columnsWidth: '34px minmax(150px, 1fr) 230px',
        columnsVisible: {
          name: true,
          description: false,
          actions: true
        }
      };

    default: //for normal large table
      return {
        columnsWidth: '34px minmax(150px, 1fr) minmax(150px, 1fr) 230px',
        columnsVisible: {
          name: true,
          description: true,
          actions: true
        }
      };
  }
};

const useSearchListTableStyles = tss
  .withParams<{ columns: string }>()
  .create(({ columns }) => ({
    // eslint-disable-next-line tss-unused-classes/unused-classes
    columns: {
      display: 'grid',
      gridTemplateColumns: columns,

      gap: '1em',
      padding: '.5em 1em',
      alignItems: 'center',
      borderBottom: '1px solid #6C757D'
    },
    // eslint-disable-next-line tss-unused-classes/unused-classes
    header: {
      borderBottom: '1px solid black'
    }
  }));
